import { Component, Output, EventEmitter } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { v_QuoteNoteBus } from '@app/cp/shared/models/v_QuoteNoteBus';
import { NoteUpd } from '@app/cp/shared/models/NoteUpd';

@Component({
    selector: 'job-notes',
    templateUrl: './job-notes.component.html',
    styleUrls: ['./job-notes.component.scss']
})
export class JobNotesComponent extends BaseGridUIComponent<v_QuoteNoteBus, null, DQOIService> {

    constructor(globals: GlobalsService, svc_data: DQOIService) {
        super(globals);
        this.svc_data = svc_data;
    }
    @Output() noteSave: EventEmitter<NoteUpd> = new EventEmitter<NoteUpd>();
    noteUpd: NoteUpd = null; //new NoteUpd();
    active: boolean = false;

    addNote() {
        this.noteUpd = new NoteUpd();
        this.active = true;
    }
    hide() {
        this.active = false;

    }
    save(note: NoteUpd) {
        this.hide();
        this.noteSave.emit(note);
    }
}

